/**
 * @generated SignedSource<<71752ce70a1a258ba52d15ef9e03a53f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicLinkTopic$data = {
  readonly name: string;
  readonly shortName: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "topicLinkTopic";
};
export type topicLinkTopic$key = {
  readonly " $data"?: topicLinkTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicLinkTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicLinkTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortName",
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "f68beea9711624f3d2dae5d80af8dd75";

export default node;
